import videoId from 'get-video-id'

interface VideoId {
  id: string
  service: 'youtube' | 'vimeo' | 'vine' | 'videopress'
}

export function getVideoId(url: string): false | VideoId {
  let result: VideoId | false = false

  const parsed = videoId(url)

  if ('id' in parsed) {
    result = parsed
  }

  return result
}
